import React from "react";
import LinkSosmed from "../linkSosmed";
import "./footer.css"

const footer = () => (
  <footer>
    <div className="social-icons">
      <LinkSosmed></LinkSosmed>
    </div>
    <p>Copyrigh ©2020 Salahuddin. All Rights Reserved</p>
  </footer>
);

export default footer;
